var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPreviewOrgChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00071,
    cy: 0.727273,
    r: 0.727273,
    fill: "#3030AD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.90891,
    cy: 2.90916,
    r: 0.727273,
    fill: "#3030AD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0906,
    cy: 2.90916,
    r: 0.727273,
    fill: "#3030AD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0906,
    cy: 13.091,
    r: 0.727273,
    fill: "#3030AD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.90891,
    cy: 13.091,
    r: 0.727273,
    fill: "#3030AD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00071,
    cy: 15.2727,
    r: 0.727273,
    fill: "#3030AD"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.727273,
    cy: 7.99998,
    r: 0.727273,
    fill: "#3030AD"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2722,
    cy: 7.99998,
    r: 0.727273,
    fill: "#3030AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18164 8.00007C2.18164 4.78677 4.78653 2.18188 7.99982 2.18188C11.2116 2.18549 13.8144 4.78827 13.818 8.00007C13.818 11.2134 11.2131 13.8182 7.99982 13.8182C4.78653 13.8182 2.18164 11.2134 2.18164 8.00007ZM3.6359 8.00005C3.6359 10.41 5.58957 12.3637 7.99954 12.3637C10.4085 12.3613 12.3608 10.409 12.3632 8.00005C12.3632 5.59008 10.4095 3.63641 7.99954 3.63641C5.58957 3.63641 3.6359 5.59008 3.6359 8.00005Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPreviewOrgChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/previewOrgChart.ae983158d41a0595e6c27e89de3c9838.svg";